<template>
  <Tab>
    <TabItem
      v-if="!$constants.isDemo"
      id="user"
      :active="active"
      :to="{
        name: 'configUser'
      }"
    >
      ユーザー情報
    </TabItem>
    <template v-if="organization.organizationId">
      <TabItem
        id="contract"
        :active="active"
        :to="{
          name: 'configContract'
        }"
      >
        利用情報
      </TabItem>
      <TabItem
        v-if="isDelegate && isStripe"
        id="payment"
        :active="active"
        :to="{
          name: 'configPayment'
        }"
      >
        請求書 &amp; 支払い
      </TabItem>
      <TabItem
        v-if="isAuthority"
        id="management"
        :active="active"
        :to="{
          name: 'configManagement'
        }"
      >
        ユーザー管理
      </TabItem>
    </template>
  </Tab>
</template>

<script>
import Tab from '@/components/Tab';
import TabItem from '@/components/TabItem';

export default {
  props: ['active'],
  components: {
    Tab,
    TabItem
  },
  computed: {
    organization() {
      return this.$store.getters['view/organization'];
    },
    plan() {
      return this.$store.state.user.plan;
    },
    isAuthority() {
      return this.organization.isAuthority;
    },
    isDelegate() {
      return this.organization.isDelegate;
    },
    isStripe() {
      return this.plan.targetService === 'stripe';
    }
  }
};
</script>
